; (function (root, factory) {
    // UMD/AMDWeb module bolierplate: https://github.com/umdjs/umd/blob/master/templates/amdWeb.js
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('UploadForm', ['jQuery', 'AlertMessage'], factory);
    } else {
        // Browser globals
        root.UploadForm = factory(root.jQuery, root.AlertMessage, root.FileUpload);
    }
}(typeof self !== 'undefined' ? self : this, function ($, AlertMessage, FileUpload) {
    'use strict';

    function Form(element) {
        if (element.tagName !== 'FORM') {
            throw new TypeError('Upload Form component expects a FORM element, got ' + element.tagName + ' instead')
        }

        if (typeof ($().ajaxForm) !== 'function') {
            throw new ReferenceError("jQuery.ajaxForm is not a function: UploadForm needs jQuery.ajaxForm to work properly");
        }

        this.container = element;

        if (!this.container) return;

        this.file = this.container.querySelector('input[type="file"]');

        if (!this.file) return;

        this.progress = this.container.querySelector('.progress');

        this.successText = this.container.dataset.successText ? this.container.dataset.successText : 'Upload successful';
        this.errorText = this.container.dataset.errorText ? this.container.dataset.errorText : 'Error:';
        this.redirectUrl = this.container.dataset.redirectUrl;

        if (!this.progress) {
            this.progress = document.createElement('div');
            this.progress.classList.add('progress');

            this.bar = document.createElement('div');
            this.bar.classList.add('bar');
            this.progress.appendChild(this.bar);

            this.percentage = document.createElement('div');
            this.percentage.classList.add('percentage');
            this.progress.appendChild(this.percentage);

            this.messages = document.createElement('div');
            this.messages.classList.add('messages');
            this.progress.appendChild(this.messages);

            this.container.appendChild(this.progress);
        }
        else {
            this.bar = this.progress.querySelector('.bar');

            if (!this.bar) {
                this.bar = document.createElement('div');
                this.bar.classList.add('bar');
                this.progress.appendChild(this.bar);
            }

            this.percentage = this.progress.querySelector('.percentage');

            if (!this.percentage) {
                this.percentage = document.createElement('div');
                this.percentage.classList.add('percentage');
                this.progress.appendChild(this.percentage);
            }

            this.messages = this.progress.querySelector('.messages');

            if (!this.messages) {
                this.messages = document.createElement('div');
                this.messages.classList.add('messages');
                this.progress.appendChild(this.messages);
            }
        }

        this.thumb = this.bar.querySelector('.thumb');

        if (!this.thumb) {
            this.thumb = document.createElement('div');
            this.thumb.classList.add('thumb');
            this.bar.appendChild(this.thumb);
        }

        this.dispatch = this.dispatch.bind(this);
        this.onsubmit = this.onsubmit.bind(this);
        this.onprogress = this.onprogress.bind(this);
        this.oncomplete = this.oncomplete.bind(this);
        this.onerror = this.onerror.bind(this);
        this.onsuccess = this.onsuccess.bind(this);

        $(this.container).ajaxForm({
            beforeSend: this.onsubmit,
            uploadProgress: this.onprogress,
            complete: this.oncomplete,
            success: this.onsuccess,
        });
    }

    Form.prototype = {
        dispatch: function (name, init) {
            var newEvent;
            try {
                newEvent = new CustomEvent(name, init)
            } catch (err) {
                newEvent = document.createEvent('CustomEvent')
                newEvent.initCustomEvent(
                    name,
                    init && typeof (init.bubbles) !== 'undefined' ? init.bubbles : true,
                    init && typeof (init.cancelable) !== 'undefined' ? init.cancelable : false,
                    init ? init.detail : null
                );
            }
            this.container.dispatchEvent(newEvent);
        },
        onsubmit: function () {
            this.container.classList.remove('-error');
            this.container.classList.add('-loading');
            this.percentage.innerText = '0%';
            this.thumb.style.width = '0%';
        },
        onprogress: function (event, position, total, percent) {
            var value = percent + '%';
            this.percentage.innerText = value;
            this.thumb.style.width = value;

            if (percent >= 100) {
                var fn = function () {
                    if (this.container.classList.contains('-success') || this.container.classList.contains('-error')) return;
                    this.container.classList.add('-processing');
                }.bind(this);

                setTimeout(fn, 750);
            }

        },
        oncomplete: function (xhr, status, $form) {
            this.container.classList.remove('-processing');

            if (xhr.status >= 200 && xhr.status <= 299) {

                var $newContainer;

                if (typeof (this.container.getAttribute('id') === 'string')) {
                    $newContainer = $(xhr.responseText).find('#' + this.container.getAttribute('id'));
                } else {
                    $newContainer = $(xhr.responseText).find('form[action="' + this.container.getAttribute('action') + '"]');
                }

                $(this.container).html($newContainer.html())

                this.container.classList.remove('-loading');

                if (this.container.querySelector('[data-ui-component="file-upload"]') && typeof(FileUpload) === 'function') {
                    var upl = new FileUpload(this.container.querySelector('[data-ui-component="file-upload"]'))
                }
            }
            else
            {
                var $newContainer;

                if (typeof (this.container.getAttribute('id') === 'string')) {
                    $newContainer = $(xhr.responseText).find('#' + this.container.getAttribute('id'));
                } else {
                    $newContainer = $(xhr.responseText).find('form[action="' + this.container.getAttribute('action') + '"]');
                }

                $(this.container).html($newContainer.html())

                this.container.classList.remove('-loading');

                if (this.container.querySelector('[data-ui-component="file-upload"]') && typeof (FileUpload) === 'function') {
                    var upl = new FileUpload(this.container.querySelector('[data-ui-component="file-upload"]'))
                }

                this.onerror(xhr.statusText);

            }
        },
        onerror: function (text) {
            this.dispatch('upload-form:error', {
                bubbles: true,
                cancelable: false,
                detail: {
                    instance: this
                }
            });

            this.container.classList.add('-error');
            this.container.classList.remove('-processing');

            var message = document.createElement('div');
            message.classList.add('message');
            message.classList.add('-error');

            message.innerText = this.errorText + ' ' + text;

            if (typeof (AlertMessage) === 'function') {
                var alert = new AlertMessage(message, {
                    dismissable: false,
                    autofade: false
                })
            }

            this.messages.appendChild(message);
        },
        onsuccess: function (data) { 
            this.dispatch('upload-form:success', {
                bubbles: true,
                cancelable: false,
                detail: {
                    instance: this
                }
            });

            if (this.redirectUrl) {
                window.location.href = this.redirectUrl;
            }
            //window.location.reload();
        }
    }

    return Form;
}));